import me from "models/me";
import type { RedirectFunction, RouterState } from "react-router";
import { getStore } from "store";
import { isAnUnconnectedBuyerFromMarketplace } from "helpers/marketplace/access-control";

export default function (flags: Record<string, boolean> = {}) {
    return function (_nextState: RouterState, replace: RedirectFunction, callback: AnyFunction) {
        const scope = getStore()?.getState()?.scope;

        if (me.isSignedIn() && isAnUnconnectedBuyerFromMarketplace(scope, flags)) {
            replace({
                pathname: "/403",
            });
        }

        callback();
    };
}
